import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo } from "react";
import { ConfirmDialog } from "@bookips/solvook-ui-library";
import useDialog from "@/hooks/useDialog";
import { getMemberships, PassCategory } from "../../../api/membership";
import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { useRouter } from "next/router";
import { EXTERNAL_CHANNEL_TALK } from "@/settings/constant";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
//여기에 컴포넌트 넣기
export const CheckSolvookPlus = (param)=>{
    let {} = param;
    const { push , back  } = useRouter();
    const { open , close , dialogProps  } = useDialog();
    const { isLoggedIn , user  } = useAuthStore();
    const { data: userMembershipResponse  } = useQuery([
        "userMembership",
        user
    ], ()=>getMemberships({}), {
        enabled: isLoggedIn
    });
    const isHasSolvookPlus = useMemo(()=>{
        if (!userMembershipResponse) return;
        return !!userMembershipResponse.unexpired.find((membership)=>membership.productInfo.category === PassCategory.Subscription || membership.productInfo.category === PassCategory.Solvookplus || membership.productInfo.categoryTitle === "쏠북 플러스" && membership.productInfo.category === PassCategory.Ticket);
    }, [
        userMembershipResponse
    ]);
    useEffect(()=>{
        if (isHasSolvookPlus) {
            open();
        }
    }, [
        isHasSolvookPlus
    ]);
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        ...dialogProps,
        title: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "쏠북 플러스를 이용 중이면,",
                /*#__PURE__*/ _jsx("br", {}),
                "엑스퍼트 이용권을 구매할 수 없어요."
            ]
        }),
        content: "자세한 문의는 고객센터를 이용해주세요.",
        okText: "돌아가기",
        onOk: ()=>{
            mixpanelEvent("Popup Button Clicked", {
                "Popup Type": "Already Subscribed",
                "Popup Title": "쏠북 플러스를 이용 중이면, 엑스퍼트 이용권을 구매할 수 없어요.",
                "Button Name": "고객센터"
            });
            back();
        },
        cancelText: "고객센터",
        onCancel: ()=>{
            mixpanelEvent("Popup Button Clicked", {
                "Popup Type": "Already Subscribed",
                "Popup Title": "쏠북 플러스를 이용 중이면, 엑스퍼트 이용권을 구매할 수 없어요.",
                "Button Name": "돌아가기"
            });
            push(EXTERNAL_CHANNEL_TALK);
        },
        onClose: null
    });
};
